import React, { useEffect, useState } from "react";
import "./sidebar.css";
import sideBarLogo from "./../../Images/logo - png.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAddressCard,
  faArrowRightFromBracket,
  faBoxArchive,
  faChevronLeft,
  faChevronRight,
  faComment,
  faDatabase,
  faFlag,
  faHeadset,
  faKey,
  faPeopleGroup,
  faSquarePollVertical,
  faUpRightFromSquare,
  faUser,
  faUserGroup,
  faUsers,
  faUsersViewfinder,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  getId,
  getRole,
  getToken,
  logout,
} from "../../RTK/Slice/Auth/AuthSlice";
import { faSearchengin, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { getUserByIdAPI } from "../../RTK/Slice/Admin/AdminSlice";

const SideBar = ({ handleShowSide, showSide }) => {
  // For Dispatch Action
  const dispatch = useDispatch();

  // For Access Token
  const token = useSelector(getToken);

  // For Get User ID
  const id = useSelector(getId);

  // For Get Data When Page Loaded
  useEffect(() => {
    if (token) {
      // For Call Get User Data API
      dispatch(getUserByIdAPI({ token, id }));
    }
  }, [dispatch, token, id]);

  // For Control Tabs
  const [messageList2, setShowMessageList2] = useState(false);

  // For Access Language
  const { t, i18n } = useTranslation();

  // For Role
  const role = useSelector(getRole);

  // For Logut and clear user Data
  const logoutHandler = () => {
    dispatch(logout());
    window.location.reload();
  };

  return (
    <aside className={`sidebar  ${showSide ? "show-side" : "hide-side"}`}>
      <div className={`side-head `}>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <img src={sideBarLogo} loading="lazy" title="sf" alt="side--log" />
          <p>RBM</p>
        </div>
        <button onClick={handleShowSide} className="hide-responsive close-btn">
          <FontAwesomeIcon icon={faXmark} />
        </button>
      </div>
      <p className="title">{t("dashboard")}</p>
      <div className="all-tabs">
        <div className="tab" onClick={handleShowSide}>
          <NavLink
            to={"/"}
            style={{ display: "block", textDecoration: "none" }}
          >
            <div className="top">
              <div className="cont">
                <div className="left">
                  <div className="tab-log">
                    <FontAwesomeIcon icon={faFlag} />
                  </div>
                  <p> {t(`tab1`)}</p>
                </div>
                <div className="right"></div>
              </div>
            </div>
          </NavLink>
          <div className="bottom"></div>
        </div>

        <div className="tab" onClick={handleShowSide}>
          <NavLink
            to={"https://smartfb.tools/test_new_token/"}
            target="_blank"
            style={{ display: "block", textDecoration: "none" }}
          >
            <div className="top">
              <div className="cont">
                <div className="left">
                  <div className="tab-log">
                    <FontAwesomeIcon icon={faKey} />
                  </div>
                  <p> {t(`tab10`)}</p>
                </div>
                <div className="right"></div>
              </div>
            </div>
          </NavLink>
          <div className="bottom"></div>
        </div>

        <div className="tab" onClick={handleShowSide}>
          <NavLink
            to={"/profile"}
            style={{ display: "block", textDecoration: "none" }}
          >
            <div className="top">
              <div className="cont">
                <div className="left">
                  <div className="tab-log">
                    <FontAwesomeIcon icon={faUser} />
                  </div>
                  <p>{t("tab2")}</p>
                </div>
                <div className="right"></div>
              </div>
            </div>
          </NavLink>
          <div className="bottom"></div>
        </div>

        <div className="tab" onClick={handleShowSide}>
          <NavLink
            to={"/manageGroups"}
            style={{ display: "block", textDecoration: "none" }}
          >
            <div className="top">
              <div className="cont">
                <div className="left">
                  <div className="tab-log">
                    <FontAwesomeIcon icon={faUserGroup} />
                  </div>
                  <p> {t(`tab3`)}</p>
                </div>
                <div className="right"></div>
              </div>
            </div>
          </NavLink>
          <div className="bottom"></div>
        </div>

        {role !== "user" ? (
          <div className="tab">
            <NavLink
              onClick={handleShowSide}
              to={"/allusers"}
              style={{ display: "block", textDecoration: "none" }}
            >
              <div className="top">
                <div className="cont">
                  <div className="left">
                    <div className="tab-log">
                      <FontAwesomeIcon icon={faUsers} />
                    </div>
                    <p>{t(`tab4`)}</p>
                  </div>
                  <div className="right"></div>
                </div>
              </div>
            </NavLink>
            <div className="bottom"></div>
          </div>
        ) : (
          ""
        )}

        <div
          className="tab"
          onClick={() => {
            setShowMessageList2(!messageList2);
          }}
        >
          <div>
            <div className={`top ${messageList2 ? "active" : ""}`}>
              <div className={`cont`}>
                <div className="left">
                  <div className="tab-log">
                    <FontAwesomeIcon icon={faDatabase} />
                  </div>
                  <p>{t(`tab5`)} </p>
                </div>
                <div className="right">
                  <FontAwesomeIcon
                    className={`${messageList2 ? (i18n.language === "ar" ? "arrow-opened-ar" : "arrow-opened") : ""}`}
                    icon={
                      i18n.language === "ar" ? faChevronLeft : faChevronRight
                    }
                  />
                </div>
              </div>
            </div>
          </div>

          <div className={`bottom ${messageList2 ? "show-bottom" : ""}`}>
            <div className="line-tools"></div>
            <div className="sub-tabs">
              <NavLink
                onClick={handleShowSide}
                to={"/extractdata/pageId"}
                className="sub-tab"
              >
                <div className="icon">
                  <FontAwesomeIcon icon={faUpRightFromSquare} />
                </div>
                <p className="sub-title"> {t(`subTab1`)}</p>
              </NavLink>
              <NavLink
                onClick={handleShowSide}
                to={"/extractdata/search"}
                className="sub-tab"
              >
                <div className="icon">
                  <FontAwesomeIcon icon={faSearchengin} />
                </div>
                <p className="sub-title">{t(`subTab2`)}</p>
              </NavLink>
              <NavLink
                onClick={handleShowSide}
                to={"/extractdata/search/extractMorePost"}
                className="sub-tab"
              >
                <div className="icon">
                  <FontAwesomeIcon icon={faBoxArchive} />
                </div>
                <p className="sub-title">{t(`subTab3`)}</p>
              </NavLink>
              <NavLink
                onClick={handleShowSide}
                to={"/extractdata/search/extractCommentsFromMorePost"}
                className="sub-tab"
              >
                <div className="icon">
                  <FontAwesomeIcon icon={faComment} />
                </div>
                <p className="sub-title"> {t(`subTab4`)}</p>
              </NavLink>
              <NavLink
                onClick={handleShowSide}
                to={"/extractdata/specifcGroup"}
                className="sub-tab"
              >
                <div className="icon">
                  <FontAwesomeIcon icon={faPeopleGroup} />
                </div>
                <p className="sub-title"> {t(`subTab5`)}</p>
              </NavLink>
              <NavLink
                onClick={handleShowSide}
                to={"/extractdata/specifcPost"}
                className="sub-tab"
              >
                <div className="icon">
                  <FontAwesomeIcon icon={faAddressCard} />
                </div>
                <p className="sub-title">{t(`subTab6`)}</p>
              </NavLink>
              <NavLink
                onClick={handleShowSide}
                to={"/extractdata/extractgroupmember"}
                className="sub-tab"
              >
                <div className="icon">
                  <FontAwesomeIcon icon={faUsersViewfinder} />
                </div>
                <p className="sub-title">{t(`subTab7`)}</p>
              </NavLink>
              <NavLink
                onClick={handleShowSide}
                to={"/extractdata/specifcPerson"}
                className="sub-tab"
              >
                <div className="icon">
                  <FontAwesomeIcon icon={faUser} />
                </div>
                <p className="sub-title"> {t(`subTab8`)}</p>
              </NavLink>
            </div>
          </div>
        </div>



        <div className="tab" onClick={handleShowSide}>
          <NavLink
            target="_blank"
            to={"https://Rbmwhats.tools/"}
            style={{ display: "block", textDecoration: "none" }}
          >
            <div className="top">
              <div className="cont">
                <div className="left">
                  <div className="tab-log">
                    <FontAwesomeIcon
                      style={{ fontSize: "16px" }}
                      icon={faWhatsapp}
                    />
                  </div>
                  <p>{t("tab7")} </p>
                </div>
                <div className="right"></div>
              </div>
            </div>
          </NavLink>
          <div className="bottom"></div>
        </div>

        <div className="tab" onClick={handleShowSide}>
          <NavLink
            target="_blank"
            to={"https://www.facebook.com/profile.php?id=61571072272088"}
            style={{ display: "block", textDecoration: "none" }}
          >
            <div className="top">
              <div className="cont">
                <div className="left">
                  <div className="tab-log">
                    <FontAwesomeIcon icon={faHeadset} />
                  </div>
                  <p> {t(`tab11`)} </p>
                </div>
                <div className="right"></div>
              </div>
            </div>
          </NavLink>
          <div className="bottom"></div>
        </div>

        {/*<div className='tab' onClick={handleShowSide}>
                <NavLink to={"/change-password"} style={{display : "block" , textDecoration :"none"}}>
                <div className='top'>
                    <div className='cont'>
                        <div className='left'>
                            <div className='tab-log'>
                                <FontAwesomeIcon icon={faUserGroup} />
                            </div>
                            <p>Change Password</p>
                        </div>
                        <div className='right'>
                            
                        </div>
                    </div>
                </div>
                </NavLink>
                <div className='bottom'></div>
            </div>*/}

        <div className="tab" onClick={logoutHandler}>
          <div style={{ display: "block", textDecoration: "none" }}>
            <div className="top">
              <div className="cont">
                <div className="left">
                  <div className="tab-log">
                    <FontAwesomeIcon icon={faArrowRightFromBracket} />
                  </div>
                  <p>{t(`tab9`)}</p>
                </div>
                <div className="right"></div>
              </div>
            </div>
          </div>
          <div className="bottom"></div>
        </div>
      </div>
    </aside>
  );
};

export default SideBar;
